import PropTypes from 'prop-types'
import { Button, Typography } from '@material-tailwind/react'

const labels = {
  pending: 'Pendiente',
  uploading: 'Subiendo',
  processing: 'Procesando en el servidor…',
  uploaded: 'Completado',
  updated: 'Actualizado',
  replacement_created: 'Candidato de reemplazo creado',
  skipped: 'Omitido',
  failed: 'Error'
}

const colors = {
  pending: 'text-gray-600',
  uploading: 'text-blue-700',
  processing: 'text-blue-700',
  uploaded: 'text-green-700',
  updated: 'text-green-700',
  replacement_created: 'text-green-700',
  skipped: 'text-amber-700',
  failed: 'text-red-700'
}

export const MassiveImportUploadProgress = ({ items, summary, isRunning, isPaused, pauseReason, onRetry, onResume }) => {
  if (items.length === 0) return null

  return (
    <section className='mt-6 rounded-lg border border-gray-200 bg-white p-5 shadow-sm'>
      <div className='flex flex-wrap items-start justify-between gap-4'>
        <div>
          <Typography variant='h6'>Progreso de carga</Typography>
          <Typography variant='small' className='text-gray-600'>
            {summary.finalized} de {summary.total} archivos finalizados — {summary.percentage}%
          </Typography>
        </div>
        <div className='flex flex-wrap gap-2'>
          {!isRunning && isPaused && summary.pending > 0 && (
            <Button size='sm' color='blue' onClick={onResume}>
              Reanudar pendientes
            </Button>
          )}
          {!isRunning && summary.failed > 0 && (
            <Button size='sm' variant='outlined' color='blue' onClick={onRetry}>
              Reintentar archivos con error
            </Button>
          )}
        </div>
      </div>

      <div className='mt-3 h-2 overflow-hidden rounded-full bg-gray-200'>
        <div
          className='h-full bg-blue-600 transition-all duration-300'
          style={{ width: `${summary.percentage}%` }}
        />
      </div>

      <div className='mt-3 flex flex-wrap gap-x-5 gap-y-1 text-sm text-gray-700'>
        <span>Exitosos: {summary.successful}</span>
        <span>Omitidos: {summary.skipped}</span>
        <span>Con error: {summary.failed}</span>
        <span>Pendientes: {summary.pending}</span>
      </div>

      {isPaused && (
        <p className='mt-3 rounded-md bg-amber-50 p-3 text-sm text-amber-800'>{pauseReason}</p>
      )}

      <div className='mt-4 max-h-80 divide-y divide-gray-200 overflow-y-auto rounded-md border border-gray-200'>
        {items.map((item) => (
          <div key={item.id} className='p-3'>
            <div className='flex items-start justify-between gap-3'>
              <span className='break-all text-sm text-gray-900'>{item.filename}</span>
              <span className={`shrink-0 text-sm font-medium ${colors[item.status] || colors.pending}`}>
                {item.status === 'uploading' ? `${labels.uploading} ${item.progress}%` : labels[item.status]}
              </span>
            </div>
            {item.status === 'uploading' && (
              <div className='mt-2 h-1.5 overflow-hidden rounded-full bg-gray-200'>
                <div className='h-full bg-blue-500' style={{ width: `${item.progress}%` }} />
              </div>
            )}
            {item.error && <p className='mt-1 text-xs text-red-700'>{item.error}</p>}
            {!item.error && item.message && <p className='mt-1 text-xs text-gray-600'>{item.message}</p>}
          </div>
        ))}
      </div>
    </section>
  )
}

MassiveImportUploadProgress.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  summary: PropTypes.object.isRequired,
  isRunning: PropTypes.bool.isRequired,
  isPaused: PropTypes.bool.isRequired,
  pauseReason: PropTypes.string,
  onRetry: PropTypes.func.isRequired,
  onResume: PropTypes.func.isRequired
}

MassiveImportUploadProgress.defaultProps = {
  pauseReason: ''
}
